document.addEventListener('DOMContentLoaded', function () {
    const productReferenceInfo = document.querySelector('.product-reference-info');
    const productReferenceInfoList = productReferenceInfo.querySelectorAll('.product-reference-info__list-title');
    productReferenceInfoList.forEach(function (header) {
        const inner = header.parentElement.querySelector('.product-reference-info__inner');
        const content = header.parentElement.querySelector('.product-reference-info__list-content');
        const icon = header.querySelector('.product-reference-info__list-icon');
        inner.setAttribute('data-height', content.clientHeight);

        header.addEventListener('click', function () {

            if (inner.classList.contains('open')) {
                inner.classList.remove('open');
                inner.style.height = '0px';
                icon.innerHTML = '<svg class="icon-plus" ><use href="#icon-plus"></use></svg>';
            } else {
                inner.classList.add('open');
                inner.style.height = inner.getAttribute('data-height') + 'px';
                icon.innerHTML = '<svg class="icon-minus" ><use href="#icon-minus"></use></svg>';
            }
       
        });
    });
});